// extracted by mini-css-extract-plugin
module.exports = {"playButtonContainer":"PlayButton_playButtonContainer__3aaTL","audio_icon":"PlayButton_audio_icon__LD8UE"};